var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col gap-2 overflow-y-auto flex-1 mx-6 pb-10"},[_c('Transition',{attrs:{"mode":"out-in"}},[(_vm.loading)?_c('HelpCenterSearchSkeleton'):(!_vm.loading && _vm.searchResults.length > 0)?_c('div',{key:_vm.searchTerm,staticClass:"flex flex-col gap-2"},_vm._l((_vm.searchResults),function(result){return _c('HelpCenterMenuItem',{key:result.id,attrs:{"label":result.value,"icon":"file"},on:{"click":function($event){return _vm.$emit(
            'articleClicked',
            result.categorySlug,
            result.articleSlug,
            result.value
          )}}})}),1):_c('HelpCenterSearchBlank')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }